import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';

import Login from '@/pages/login/login';
import Main from '@/pages/main/main';
import Startet from '@/pages/startet/startet';
import Cases from '@/pages/cases/cases';
import Search from '@/pages/search/search';
import Focus from '@/pages/focus/focus';

import { Layout } from '../Layout';

export default function AppRouter() {
  const routes = createBrowserRouter([
    {
      path: '/',
      element: <Layout />,
      children: [
        {
          path: '/',
          element: <Navigate to="/claims" replace />,
        },
        {
          path: '/claims',
          element: <Main />,
        },
        {
          path: '/startet',
          element: <Startet />,
        },
        {
          path: '/cases',
          element: <Cases />,
        },
        {
          path: '/search',
          element: <Search />,
        },
        {
          path: '/focus',
          element: <Focus />,
        },
      ],
    },
    {
      path: '/login',
      element: <Login />,
    },
  ]);

  return <RouterProvider router={routes} />;
}
